import {call, put, takeEvery} from "redux-saga/effects"

import {getOffices as getOfficesApi, postOffice as postOfficeApi,} from "../../helpers/backend_helper";
import {OfficeTypes} from "./actionsTypes";
import {addOfficeFail, addOfficeSuccess, getOfficesFail, getOfficesSuccess, modalOffice} from "./actions";

function* fetchOfficesSaga({next_page, filter}: any) {
    try {
        const response: Promise<any> = yield call(getOfficesApi, next_page, filter);

        yield put(getOfficesSuccess(response))
    } catch (error) {
        yield put(getOfficesFail(error));
    }
}

function* addOfficeSaga({data}: any) {
    try {
        const response: Promise<any> = yield call(postOfficeApi, data);

        yield put(addOfficeSuccess(response));
        yield put(modalOffice(false))
    } catch (error) {
        yield put(addOfficeFail(error));
    }
}

function* officesSaga() {
    yield takeEvery(OfficeTypes.GET_OFFICES, fetchOfficesSaga)
    yield takeEvery(OfficeTypes.ADD_OFFICE, addOfficeSaga)
}

export default officesSaga;